/* ===========================================================
ADA FIXES
Craft Theme
Version 3
===========================================================*/

function fixADA(){

    /* ------------------------------------------
       BUTTON LABELS
    ------------------------------------------*/

    document.querySelectorAll("button").forEach(function(btn){

        if(btn.hasAttribute("data-ada-fixed")) return;

        if(
            btn.innerText.trim()==="" &&
            !btn.hasAttribute("aria-label")
        ){

            if(btn.className.includes("Grabber")){
                btn.setAttribute("aria-label","Open accessibility settings");
            }
            else if(btn.className.includes("IconButton")){
                btn.setAttribute("aria-label","Open menu");
            }
            else{
                btn.setAttribute("aria-label","Button");
            }

        }

        btn.setAttribute("data-ada-fixed","true");

    });


    /* ------------------------------------------
       EMPTY LINKS
    ------------------------------------------*/

    document.querySelectorAll("a.custom-link").forEach(function(link){

        if(link.hasAttribute("data-ada-fixed")) return;

        if(link.textContent.trim()===""){

            if(link.href.includes("/products")){
                link.setAttribute("aria-label","View Product");
            }
            else if(link.href.includes("/collections")){
                link.setAttribute("aria-label","View Collection");
            }
            else{
                link.setAttribute("aria-label","View Page");
            }

        }

        link.setAttribute("data-ada-fixed","true");

    });


    /* ------------------------------------------
       IFRAMES
    ------------------------------------------*/

    document.querySelectorAll("iframe").forEach(function(frame){
        if(!frame.title){
            frame.title="Embedded Content";
        }
    });


    /* ------------------------------------------
       YOTPO CONTRAST FALLBACK
       Forces color with inline important priority,
       which beats Yotpo's own injected stylesheet.
    ------------------------------------------*/

    var yotpoSelectors = [
        ".review-content",
        ".review-title",
        ".reviewer-display-name",
        ".reviews-bottomline-total-reviews"
    ];

    yotpoSelectors.forEach(function(sel){
        document.querySelectorAll(sel).forEach(function(el){
            el.style.setProperty("color", "#222222", "important");
        });
    });

    document.querySelectorAll(".yotpo-read-more-btn").forEach(function(el){
        el.style.setProperty("color", "#0047cc", "important");
    });


    /* ------------------------------------------
       LANDMARK FIXES
    ------------------------------------------*/

    function wrapInLandmark(el, role, label){
        if(!el || el.closest("[data-ada-landmark]")) return;
        if(el.closest("main,nav,header,footer,aside,[role]")) return;

        var wrapper = document.createElement("div");
        wrapper.setAttribute("role", role);
        wrapper.setAttribute("aria-label", label);
        wrapper.setAttribute("data-ada-landmark", "true");

        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
    }

    // Skip to content link
    wrapInLandmark(
        document.querySelector(".skip-to-content-link"),
        "navigation",
        "Skip to content"
    );

    // EcomSend popup widget
    var ecomsend = document.querySelector(".ecomsend__Popover__Widget__Text");
    if(ecomsend){
        wrapInLandmark(
            ecomsend.closest("div") || ecomsend,
            "region",
            "Discount offer"
        );
    }

    // Upcart cart drawer
    var upcart = document.querySelector("[data-upcart-chunk]");
    if(upcart){
        var upcartRoot = upcart.closest("#upcart-drawer, .upcart, [class*='upcart']") || upcart;
        wrapInLandmark(upcartRoot, "region", "Shopping cart");
    }

}

/* Initial Run */
fixADA();

/* Watch for Apps Adding New HTML */
const observer = new MutationObserver(function(){
    fixADA();
});

observer.observe(document.body,{
    childList:true,
    subtree:true
});

/* ------------------------------------------
       YOTPO AAA CONTRAST FALLBACK
    ------------------------------------------*/

    document.querySelectorAll(".yotpo-reviews-carousel-header").forEach(function(el){
        el.style.setProperty("color", "#5c4f3f", "important");
    });

    ["review-date", "review-product-name", "reviewer-status-text"].forEach(function(cls){
        document.querySelectorAll("." + cls).forEach(function(el){
            el.style.setProperty("color", "#444444", "important");
        });
    });

   /* ------------------------------------------
       UPCART LANDMARK, DIRECT ATTRIBUTE METHOD
    ------------------------------------------*/

    document.querySelectorAll(
        '[data-upcart-chunk="header-title-content"], [data-upcart-chunk="rewards-message"], .styles_CartPreview__empty__body__'
    ).forEach(function(el){
        if(el.hasAttribute("data-ada-landmark")) return;
        el.setAttribute("role", "region");
        el.setAttribute("aria-label", "Cart information");
        el.setAttribute("data-ada-landmark", "true");
    });

   